export enum Role {
	PLAYER = 'player',
	ADMIN = 'admin',
	MODERATOR = 'moderator',
	DEVELOPER = 'developer',
	PROMOCODES = 'promocodes',
}
